var _path, _path2, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoPlayIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 7.16683C1.66699 4.41697 1.66699 3.04204 2.52126 2.18777C3.37554 1.3335 4.75047 1.3335 7.50033 1.3335H8.33366C11.0835 1.3335 12.4584 1.3335 13.3127 2.18777C14.167 3.04204 14.167 4.41697 14.167 7.16683V8.8335C14.167 11.5834 14.167 12.9583 13.3127 13.8126C12.4584 14.6668 11.0835 14.6668 8.33366 14.6668H7.50032C4.75047 14.6668 3.37554 14.6668 2.52126 13.8126C1.66699 12.9583 1.66699 11.5834 1.66699 8.8335V7.16683Z",
    stroke: "#3348FF",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.167 5.42187L14.2719 5.33529C16.0351 3.88052 16.9166 3.15313 17.6251 3.50434C18.3337 3.85556 18.3337 5.01995 18.3337 7.34873V8.65192C18.3337 10.9807 18.3337 12.1451 17.6251 12.4963C16.9166 12.8475 16.0351 12.1201 14.2719 10.6654L14.167 10.5788",
    stroke: "#3348FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.58398,
    cy: 5.91699,
    rx: 1.25,
    ry: 1.25,
    stroke: "#14181F",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlayIconWhite);
export default __webpack_public_path__ + "static/media/video-play-icon-white.db21274497b28a18bfe3e6e334dfa8ed.svg";
export { ForwardRef as ReactComponent };